import {
  Patient,
  Doctor,
  Appointment,
  Contact,
  Opportunity,
  Service,
  Insurance,
  Specialty,
  ClinicalHistory,
  AuditLog } from
'../types';
import { formatDate, getGenderName, getStatusName } from './helpers';

// Logo circular Savidna (SV) incrustado en el encabezado de los reportes
const SAVIDNA_LOGO_B64 = "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";
// ============================================================================
//  MOTOR DE EXPORTACIÓN A EXCEL (.xlsx nativo vía ExcelJS)
//  Replica el lenguaje visual del export PDF: barra de acento cian, logo
//  Savidna real incrustado, título, subtítulo, cabecera cian, filas alternas,
//  fila de totales destacada y pie "Documento Confidencial".
//
//  Se usa .xlsx nativo (no HTML renombrado a .xls) para poder incrustar el
//  logo de verdad y para que los estilos se vean igual en Excel, LibreOffice,
//  Google Sheets y Numbers, sin la advertencia de "el formato del archivo no
//  coincide con la extensión".
// ============================================================================

// ---------------------------------------------------------------------------
//  Carga de ExcelJS desde CDN, bajo demanda.
//
//  Se carga en tiempo de ejecución en lugar de importarlo como dependencia
//  para que el bundler no tenga que resolver "exceljs". Así el módulo funciona
//  aunque el entorno de build no tenga el paquete instalado, y la librería
//  (~940 KB) solo se descarga la primera vez que alguien exporta: quien nunca
//  usa el botón de exportar nunca la baja.
//
//  Si prefieres empaquetarla, ejecuta `npm install exceljs` y sustituye la
//  llamada a loadExcelJS() por:
//      const ExcelJS = (await import('exceljs')).default;
// ---------------------------------------------------------------------------
const EXCELJS_VERSION = '4.4.0';
const EXCELJS_CDN = `https://cdn.jsdelivr.net/npm/exceljs@${EXCELJS_VERSION}/dist/exceljs.min.js`;

let excelJsLoader: Promise<any> | null = null;

const loadExcelJS = (): Promise<any> => {
  const alreadyLoaded = (window as any).ExcelJS;
  if (alreadyLoaded) return Promise.resolve(alreadyLoaded);
  if (excelJsLoader) return excelJsLoader;

  excelJsLoader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = EXCELJS_CDN;
    script.async = true;
    script.onload = () => {
      const lib = (window as any).ExcelJS;
      if (lib) {
        resolve(lib);
      } else {
        excelJsLoader = null;
        reject(new Error('ExcelJS se descargó pero no se pudo inicializar'));
      }
    };
    script.onerror = () => {
      // Permite reintentar en la siguiente exportación
      excelJsLoader = null;
      reject(new Error('No se pudo descargar ExcelJS'));
    };
    document.head.appendChild(script);
  });
  return excelJsLoader;
};

type ExcelAlign = 'left' | 'center' | 'right';
type ExcelFormat =
'text' |
'number' |
'decimal' |
'currency' |
'percent' |
'date';

interface ExcelColumn {
  header: string;
  key: string;
  /** Ancho aproximado en píxeles (se convierte a unidades de Excel) */
  width?: number;
  align?: ExcelAlign;
  format?: ExcelFormat;
}
interface ExcelRow {
  [key: string]: string | number | boolean;
}
interface ExcelOptions {
  /** Línea extra junto al subtítulo (ej: "01/01/2025 al 31/01/2025") */
  subtitle?: string;
  /** Chips informativos: filtros aplicados, totales por estado, etc. */
  meta?: string[];
}

/** Paleta idéntica a la usada en pdfExport.ts */
const XLS_THEME = {
  primary: 'FF06B6D4',
  primaryDark: 'FF0891B2',
  headerText: 'FFFFFFFF',
  rowEven: 'FFF0FDFA',
  rowOdd: 'FFFFFFFF',
  border: 'FFE5E7EB',
  text: 'FF111827',
  muted: 'FF6B7280',
  metaBg: 'FFECFEFF',
  metaBorder: 'FFA5F3FC'
};

/** Formatos numéricos nativos de Excel */
const XLS_NUMFMT: Record<ExcelFormat, string> = {
  text: '@',
  number: '#,##0',
  decimal: '#,##0.00',
  currency: '"RD$" #,##0.00',
  percent: '0.0%',
  date: 'dd/mm/yyyy'
};

/** Pistas para deducir el formato de una columna a partir de su nombre */
const CURRENCY_HINTS = [
'total',
'precio',
'monto',
'costo',
'ingreso',
'ganancia',
'comision',
'descuento',
'pago',
'saldo',
'subtotal',
'valor',
'abono',
'balance'];

const TEXT_HINTS = [
'id',
'telefono',
'celular',
'cedula',
'sku',
'codigo',
'rnc',
'whatsapp',
'nss'];

const NUMBER_HINTS = [
'cantidad',
'unidades',
'stock',
'duracion',
'edad',
'probabilidad',
'registros',
'sesiones',
'puntos'];


const normalizeKey = (s: string) =>
s.
toLowerCase().
normalize('NFD').
replace(/[\u0300-\u036f]/g, '');

/** Deduce el formato de la columna si no viene declarado explícitamente */
const detectFormat = (
col: ExcelColumn,
sample: string | number | boolean | undefined)
: ExcelFormat => {
  if (col.format) return col.format;
  const hay = normalizeKey(`${col.key} ${col.header}`);
  const tokens = hay.split(/[^a-z0-9]+/);
  if (TEXT_HINTS.some((h) => tokens.includes(h))) return 'text';
  if (CURRENCY_HINTS.some((h) => hay.includes(h))) return 'currency';
  if (typeof sample === 'number') {
    if (NUMBER_HINTS.some((h) => hay.includes(h))) return 'number';
    return Number.isInteger(sample) ? 'number' : 'decimal';
  }
  return 'text';
};

const alignFor = (col: ExcelColumn, fmt: ExcelFormat): ExcelAlign =>
col.align ?? (
fmt === 'currency' || fmt === 'number' || fmt === 'decimal' || fmt === 'percent' ?
'right' :
'left');

/** Excel mide el ancho en caracteres, no en píxeles */
const pxToChars = (px: number) => Math.max(8, Math.round(px / 7));

/**
 * Genera y descarga un archivo .xlsx con el diseño del export PDF.
 */
const downloadFormattedExcel = async (
data: ExcelRow[],
columns: ExcelColumn[],
filename: string,
sheetName: string,
title: string,
totalsRow?: ExcelRow,
options: ExcelOptions = {}) =>
{
  if (data.length === 0) {
    alert('No hay datos para exportar');
    return;
  }

  // Carga diferida de ExcelJS (ver loadExcelJS más arriba)
  let ExcelJS: any;
  try {
    ExcelJS = await loadExcelJS();
  } catch {
    alert(
      'No se pudo cargar el generador de Excel. Verifica tu conexión a internet e inténtalo de nuevo.'
    );
    return;
  }

  const nCols = columns.length;
  const today = new Date().toLocaleDateString('es-DO');
  const sampleRow = data[0] || {};

  const colMeta = columns.map((col) => {
    const fmt = detectFormat(col, sampleRow[col.key]);
    return {
      col,
      fmt,
      align: alignFor(col, fmt),
      numFmt: XLS_NUMFMT[fmt]
    };
  });

  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'Savidna - Centro de Bienestar y Belleza';
  workbook.created = new Date();

  const sheet = workbook.addWorksheet(sheetName.substring(0, 31), {
    pageSetup: {
      orientation: 'landscape',
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 0,
      horizontalCentered: true,
      margins: {
        left: 0.4,
        right: 0.4,
        top: 0.5,
        bottom: 0.5,
        header: 0.3,
        footer: 0.3
      }
    }
  });

  sheet.columns = colMeta.map((m) => ({
    width: pxToChars(m.col.width ?? 140)
  }));

  const thinBorder = {
    top: { style: 'thin' as const, color: { argb: XLS_THEME.border } },
    left: { style: 'thin' as const, color: { argb: XLS_THEME.border } },
    bottom: { style: 'thin' as const, color: { argb: XLS_THEME.border } },
    right: { style: 'thin' as const, color: { argb: XLS_THEME.border } }
  };
  const headerBorder = {
    top: { style: 'thin' as const, color: { argb: XLS_THEME.primaryDark } },
    left: { style: 'thin' as const, color: { argb: XLS_THEME.primaryDark } },
    bottom: { style: 'thin' as const, color: { argb: XLS_THEME.primaryDark } },
    right: { style: 'thin' as const, color: { argb: XLS_THEME.primaryDark } }
  };
  const fillWith = (argb: string) => (
  {
    type: 'pattern' as const,
    pattern: 'solid' as const,
    fgColor: { argb }
  });

  const mergeAcross = (rowNumber: number, fromCol = 1) => {
    if (nCols > fromCol) sheet.mergeCells(rowNumber, fromCol, rowNumber, nCols);
  };

  let r = 1;

  // --- Barra de acento superior (igual que el PDF) ---
  const accentRow = sheet.getRow(r);
  accentRow.height = 4;
  for (let c = 1; c <= nCols; c++) {
    accentRow.getCell(c).fill = fillWith(XLS_THEME.primary);
  }
  mergeAcross(r);
  r++;

  // --- Título (el logo se ancla flotando sobre estas filas) ---
  const titleRowNumber = r;
  const titleRow = sheet.getRow(r);
  titleRow.height = 26;
  const titleCell = titleRow.getCell(nCols > 1 ? 2 : 1);
  titleCell.value = title;
  titleCell.font = {
    name: 'Arial',
    size: 18,
    bold: true,
    color: { argb: XLS_THEME.primary }
  };
  titleCell.alignment = { vertical: 'bottom', horizontal: 'left' };
  mergeAcross(r, nCols > 1 ? 2 : 1);
  r++;

  // --- Subtítulo ---
  const subtitleParts = [
  'Savidna - Centro de Bienestar y Belleza',
  `${data.length} ${data.length === 1 ? 'registro' : 'registros'}`,
  today];

  const subtitleRow = sheet.getRow(r);
  subtitleRow.height = 16;
  const subtitleCell = subtitleRow.getCell(nCols > 1 ? 2 : 1);
  subtitleCell.value = options.subtitle ?
  `${options.subtitle}  |  ${subtitleParts.join('  |  ')}` :
  subtitleParts.join('  |  ');
  subtitleCell.font = {
    name: 'Arial',
    size: 9,
    color: { argb: XLS_THEME.muted }
  };
  subtitleCell.alignment = { vertical: 'top', horizontal: 'left' };
  mergeAcross(r, nCols > 1 ? 2 : 1);
  r++;

  // --- Logo real incrustado, anclado sobre las filas de título ---
  try {
    const imageId = workbook.addImage({
      base64: SAVIDNA_LOGO_B64,
      extension: 'jpeg'
    });
    sheet.addImage(imageId, {
      tl: { col: 0.12, row: titleRowNumber - 1 + 0.08 },
      ext: { width: 46, height: 46 },
      editAs: 'oneCell'
    });
  } catch {



    // Si el logo falla, el reporte se genera igual sin él
  } // --- Línea divisoria ---
  const dividerRow = sheet.getRow(r);
  dividerRow.height = 5;
  for (let c = 1; c <= nCols; c++) {
    dividerRow.getCell(c).border = {
      bottom: { style: 'medium', color: { argb: XLS_THEME.primary } }
    };
  }
  mergeAcross(r);
  r++;

  sheet.getRow(r).height = 6;
  r++;

  // --- Chips de metadatos (filtros aplicados, rangos, etc.) ---
  if (options.meta && options.meta.length > 0) {
    const metaRow = sheet.getRow(r);
    metaRow.height = 20;
    const metaCell = metaRow.getCell(1);
    metaCell.value = options.meta.join('   |   ');
    metaCell.font = {
      name: 'Arial',
      size: 9,
      color: { argb: XLS_THEME.muted }
    };
    metaCell.alignment = { vertical: 'middle', horizontal: 'left' };
    metaCell.fill = fillWith(XLS_THEME.metaBg);
    metaCell.border = {
      top: { style: 'thin', color: { argb: XLS_THEME.metaBorder } },
      left: { style: 'thin', color: { argb: XLS_THEME.metaBorder } },
      bottom: { style: 'thin', color: { argb: XLS_THEME.metaBorder } },
      right: { style: 'thin', color: { argb: XLS_THEME.metaBorder } }
    };
    mergeAcross(r);
    r++;
    sheet.getRow(r).height = 6;
    r++;
  }

  // --- Cabecera de la tabla ---
  const headerRowNumber = r;
  const headerRow = sheet.getRow(r);
  headerRow.height = 24;
  colMeta.forEach((m, i) => {
    const cell = headerRow.getCell(i + 1);
    cell.value = m.col.header;
    cell.font = {
      name: 'Arial',
      size: 10,
      bold: true,
      color: { argb: XLS_THEME.headerText }
    };
    cell.fill = fillWith(XLS_THEME.primary);
    cell.alignment = {
      vertical: 'middle',
      horizontal: m.align,
      wrapText: true
    };
    cell.border = headerBorder;
  });
  r++;

  // --- Filas de datos ---
  data.forEach((row, idx) => {
    const dataRow = sheet.getRow(r);
    dataRow.height = 18;
    const bg = idx % 2 === 1 ? XLS_THEME.rowEven : XLS_THEME.rowOdd;
    colMeta.forEach((m, i) => {
      const cell = dataRow.getCell(i + 1);
      const raw = row[m.col.key];
      cell.value = raw === undefined || raw === null ? '' : raw;
      cell.numFmt = m.numFmt;
      cell.font = { name: 'Arial', size: 10, color: { argb: XLS_THEME.text } };
      cell.fill = fillWith(bg);
      cell.alignment = { vertical: 'top', horizontal: m.align };
      cell.border = thinBorder;
    });
    r++;
  });

  // --- Fila de totales (mismo acento cian del PDF) ---
  if (totalsRow) {
    const totalRow = sheet.getRow(r);
    totalRow.height = 22;
    colMeta.forEach((m, i) => {
      const cell = totalRow.getCell(i + 1);
      const raw = totalsRow[m.col.key];
      cell.value = raw === undefined || raw === null ? '' : raw;
      cell.numFmt = m.numFmt;
      cell.font = {
        name: 'Arial',
        size: 10.5,
        bold: true,
        color: { argb: XLS_THEME.headerText }
      };
      cell.fill = fillWith(XLS_THEME.primary);
      cell.alignment = { vertical: 'middle', horizontal: m.align };
      cell.border = headerBorder;
    });
    r++;
  }

  // --- Pie ---
  sheet.getRow(r).height = 8;
  r++;
  const footRow = sheet.getRow(r);
  footRow.height = 16;
  const footCell = footRow.getCell(1);
  footCell.value = `Savidna - Documento Confidencial   |   Generado el ${today}`;
  footCell.font = {
    name: 'Arial',
    size: 8,
    color: { argb: XLS_THEME.muted }
  };
  footCell.border = {
    top: { style: 'thin', color: { argb: XLS_THEME.border } }
  };
  mergeAcross(r);

  // --- Cabecera congelada, filtros y repetición al imprimir ---
  sheet.views = [
  {
    state: 'frozen',
    ySplit: headerRowNumber,
    showGridLines: false
  }];

  sheet.autoFilter = {
    from: { row: headerRowNumber, column: 1 },
    to: { row: headerRowNumber, column: nCols }
  };
  sheet.pageSetup.printTitlesRow = `${headerRowNumber}:${headerRowNumber}`;

  // --- Descarga ---
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const safeName = filename.replace(/\.xlsx?$/i, '') + '.xlsx';
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', safeName);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const exportPatientsToExcel = (
patients: Patient[],
getInsuranceName: (id: string | null) => string) =>
{
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Edad',
    key: 'edad',
    width: 80
  },
  {
    header: 'Sexo',
    key: 'sexo',
    width: 100
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  },
  {
    header: 'Dirección',
    key: 'direccion',
    width: 300
  },
  {
    header: 'Seguro',
    key: 'seguro',
    width: 200
  },
  {
    header: 'Fecha de Registro',
    key: 'fecha',
    width: 150
  }];


  const data: ExcelRow[] = patients.map((patient) => ({
    id: patient.id,
    nombre: patient.name,
    edad: patient.age,
    sexo: getGenderName(patient.gender),
    telefono: patient.phone,
    email: patient.email,
    direccion: patient.address,
    seguro: getInsuranceName(patient.insuranceId),
    fecha: formatDate(patient.createdAt)
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `pacientes_${timestamp}.xlsx`,
    'Pacientes',
    'Listado de Pacientes'
  );
};
export const exportDoctorsToExcel = (
doctors: Doctor[],
getSpecialtyName: (id: string) => string) =>
{
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Especialidad',
    key: 'especialidad',
    width: 200
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  },
  {
    header: 'Fecha de Registro',
    key: 'fecha',
    width: 150
  }];


  const data: ExcelRow[] = doctors.map((doctor) => ({
    id: doctor.id,
    nombre: doctor.name,
    especialidad: getSpecialtyName(doctor.specialtyId),
    telefono: doctor.phone,
    email: doctor.email,
    fecha: formatDate(doctor.createdAt)
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `doctores_${timestamp}.xlsx`,
    'Doctores',
    'Listado de Doctores'
  );
};
export const exportAppointmentsToExcel = (
appointments: Appointment[],
getPatientName: (id: string) => string,
getDoctorName: (id: string) => string,
getServiceName: (id: string) => string,
getServicePrice: (id: string) => number,






getDiscountPercent?: (appointment: Appointment, serviceId: string) => number) =>
{
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 130,
    format: 'text'
  },
  {
    header: 'Paciente',
    key: 'paciente',
    width: 200
  },
  {
    header: 'Doctor',
    key: 'doctor',
    width: 190
  },
  {
    header: 'Servicios',
    key: 'servicio',
    width: 250
  },
  {
    header: 'Fecha',
    key: 'fecha',
    width: 100,
    align: 'center'
  },
  {
    header: 'Hora',
    key: 'hora',
    width: 80,
    align: 'center'
  },
  {
    header: 'Duración (min)',
    key: 'duracion',
    width: 110,
    format: 'number',
    align: 'center'
  },
  {
    header: 'Subtotal (DOP)',
    key: 'subtotal',
    width: 130,
    format: 'currency'
  },
  {
    header: 'Descuento',
    key: 'descuentoDetalle',
    width: 150,
    align: 'center'
  },
  {
    header: 'Descuento (DOP)',
    key: 'descuento',
    width: 130,
    format: 'currency'
  },
  {
    header: 'Total (DOP)',
    key: 'total',
    width: 130,
    format: 'currency'
  },
  {
    header: 'Estado',
    key: 'estado',
    width: 120,
    align: 'center'
  },
  {
    header: 'Creada por',
    key: 'creadaPor',
    width: 170
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 280
  },
  {
    header: 'Fecha de Creación',
    key: 'fechaCreacion',
    width: 140,
    align: 'center'
  }];


  const data: ExcelRow[] = appointments.map((apt) => {
    const serviceIds =
    apt.serviceIds && apt.serviceIds.length > 0 ?
    apt.serviceIds :
    [apt.serviceId].filter(Boolean);
    const serviceNames = serviceIds.map((id) => getServiceName(id)).join(', ');
    const discounts = apt.serviceDiscounts || {};
    const resolveDiscount = (id: string) =>
    getDiscountPercent ?
    Number(getDiscountPercent(apt, id) || 0) :
    Number(discounts[id] || 0);
    const subtotal = serviceIds.reduce(
      (sum, id) => sum + (getServicePrice(id) || 0),
      0
    );
    const descuento = serviceIds.reduce((sum, id) => {
      const price = getServicePrice(id) || 0;
      return sum + price * (resolveDiscount(id) / 100);
    }, 0);
    const total = Math.max(0, subtotal - descuento);
    // Detalle legible del descuento: un solo % si es igual para todos los
    // servicios, o "Servicio -X%" cuando hay varios porcentajes distintos.
    const detalles = serviceIds.
    map((id) => ({
      nombre: getServiceName(id),
      pct: resolveDiscount(id)
    })).
    filter((d) => d.pct > 0);
    const pcts = Array.from(new Set(detalles.map((d) => d.pct)));
    const descuentoDetalle =
    detalles.length === 0 ?
    '—' :
    pcts.length === 1 && detalles.length === serviceIds.length ?
    `-${pcts[0]}%` :
    detalles.map((d) => `${d.nombre} -${d.pct}%`).join(', ');
    return {
      id: apt.id,
      paciente: getPatientName(apt.patientId),
      doctor: getDoctorName(apt.doctorId),
      servicio: serviceNames,
      fecha: apt.date,
      hora: apt.time,
      duracion: apt.duration,
      subtotal,
      descuentoDetalle,
      descuento,
      total,
      estado: getStatusName(apt.status),
      creadaPor: apt.createdByUserName || '—',
      notas: apt.notes || '',
      fechaCreacion: formatDate(apt.createdAt)
    };
  });
  const grandTotal = data.reduce((sum, row) => sum + (Number(row.total) || 0), 0);

  // Resumen por estado para los chips informativos del encabezado.
  // Se evita `reduce<Record<...>>` a propósito: los argumentos genéricos en
  // una llamada rompen el build si el bundler parsea los .ts con JSX activo.
  const statusCount: Record<string, number> = {};
  data.forEach((row) => {
    const key = String(row.estado || 'Sin estado');
    statusCount[key] = (statusCount[key] || 0) + 1;
  });
  const statusChips = Object.entries(statusCount).map(
    ([name, count]) => `${name}: ${count}`
  );
  const dates = data.
  map((row) => String(row.fecha || '')).
  filter(Boolean).
  sort();
  const rangeChip =
  dates.length > 0 ? `Rango: ${dates[0]} al ${dates[dates.length - 1]}` : '';

  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `citas_${timestamp}.xlsx`,
    'Citas',
    'Listado de Citas',
    {
      servicio: 'TOTAL GENERAL',
      duracion: data.reduce((sum, row) => sum + (Number(row.duracion) || 0), 0),
      subtotal: data.reduce(
        (sum, row) => sum + (Number(row.subtotal) || 0),
        0
      ),
      descuento: data.reduce(
        (sum, row) => sum + (Number(row.descuento) || 0),
        0
      ),
      total: grandTotal
    },
    {
      meta: [rangeChip, ...statusChips].filter(Boolean)
    }
  );
};
export const exportServicesToExcel = (services: Service[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Duración (min)',
    key: 'duracion',
    width: 120
  },
  {
    header: 'Precio (DOP)',
    key: 'precio',
    width: 120
  },
  {
    header: 'Descripción',
    key: 'descripcion',
    width: 300
  }];


  const data: ExcelRow[] = services.map((service) => ({
    id: service.id,
    nombre: service.name,
    duracion: service.duration,
    precio: service.price,
    descripcion: service.description || ''
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `servicios_${timestamp}.xlsx`,
    'Servicios',
    'Listado de Servicios'
  );
};
export const exportInsurancesToExcel = (insurances: Insurance[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Compañía',
    key: 'compania',
    width: 200
  },
  {
    header: 'Tipo de Cobertura',
    key: 'cobertura',
    width: 150
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  }];


  const data: ExcelRow[] = insurances.map((insurance) => ({
    id: insurance.id,
    nombre: insurance.name,
    compania: insurance.company,
    cobertura: insurance.coverageType,
    telefono: insurance.phone,
    email: insurance.email
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `seguros_${timestamp}.xlsx`,
    'Seguros',
    'Listado de Seguros'
  );
};
export const exportSpecialtiesToExcel = (specialties: Specialty[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Descripción',
    key: 'descripcion',
    width: 400
  }];


  const data: ExcelRow[] = specialties.map((specialty) => ({
    id: specialty.id,
    nombre: specialty.name,
    descripcion: specialty.description
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `especialidades_${timestamp}.xlsx`,
    'Especialidades',
    'Listado de Especialidades'
  );
};
export const exportContactsToExcel = (contacts: Contact[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Empresa',
    key: 'empresa',
    width: 200
  },
  {
    header: 'Cargo',
    key: 'cargo',
    width: 150
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 300
  },
  {
    header: 'Fecha de Registro',
    key: 'fecha',
    width: 150
  }];


  const data: ExcelRow[] = contacts.map((contact) => ({
    id: contact.id,
    nombre: contact.name,
    empresa: contact.company,
    cargo: contact.position,
    telefono: contact.phone,
    email: contact.email,
    notas: contact.notes || '',
    fecha: formatDate(contact.createdAt)
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `contactos_${timestamp}.xlsx`,
    'Contactos',
    'Listado de Contactos'
  );
};
export const exportFollowUpNotesToExcel = (notes: any[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Fecha',
    key: 'fecha',
    width: 150
  },
  {
    header: 'Usuario',
    key: 'usuario',
    width: 200
  },
  {
    header: 'Contacto',
    key: 'contacto',
    width: 200
  },
  {
    header: 'Asunto',
    key: 'asunto',
    width: 250
  },
  {
    header: 'Descripción',
    key: 'descripcion',
    width: 400
  }];


  const data: ExcelRow[] = notes.map((note) => ({
    id: note.id,
    fecha: formatDate(note.createdAt),
    usuario: note.userName,
    contacto: note.contactName,
    asunto: note.subject,
    descripcion: note.description
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `notas_seguimiento_${timestamp}.xlsx`,
    'Notas',
    'Notas de Seguimiento'
  );
};
export const exportOpportunitiesToExcel = (opportunities: Opportunity[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Empresa',
    key: 'empresa',
    width: 200
  },
  {
    header: 'Industria',
    key: 'industria',
    width: 150
  },
  {
    header: 'Tamaño',
    key: 'tamano',
    width: 150
  },
  {
    header: 'Ubicación',
    key: 'ubicacion',
    width: 150
  },
  {
    header: 'Etapa',
    key: 'etapa',
    width: 150
  },
  {
    header: 'Monto (DOP)',
    key: 'monto',
    width: 120
  },
  {
    header: 'Probabilidad (%)',
    key: 'probabilidad',
    width: 120
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 300
  },
  {
    header: 'Fecha de Creación',
    key: 'fecha',
    width: 150
  }];


  const data: ExcelRow[] = opportunities.map((opp) => ({
    id: opp.id,
    nombre: opp.name,
    empresa: opp.company,
    industria: opp.industry,
    tamano: opp.size,
    ubicacion: opp.location,
    etapa: opp.stage,
    monto: opp.amount,
    probabilidad: opp.probability,
    notas: opp.notes || '',
    fecha: formatDate(opp.createdAt)
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `oportunidades_${timestamp}.xlsx`,
    'Oportunidades',
    'Listado de Oportunidades'
  );
};
export const exportClinicalHistoriesToExcel = (
histories: ClinicalHistory[],
getPatientName: (id: string) => string) =>
{
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Paciente',
    key: 'paciente',
    width: 200
  },
  {
    header: 'Doctor',
    key: 'doctor',
    width: 200
  },
  {
    header: 'Fecha',
    key: 'fecha',
    width: 120
  },
  {
    header: 'Motivo de Consulta',
    key: 'motivo',
    width: 300
  },
  {
    header: 'Diagnóstico',
    key: 'diagnostico',
    width: 300
  },
  {
    header: 'Tratamiento',
    key: 'tratamiento',
    width: 300
  },
  {
    header: 'Fecha de Creación',
    key: 'fechaCreacion',
    width: 150
  }];


  const data: ExcelRow[] = histories.map((history) => ({
    id: history.id,
    paciente: getPatientName(history.patientId),
    doctor: history.doctorName,
    fecha: formatDate(history.date),
    motivo: history.personalBackground.consultationReason || '',
    diagnostico: history.diagnosis || '',
    tratamiento: history.treatment || '',
    fechaCreacion: formatDate(history.createdAt)
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `historiales_clinicos_${timestamp}.xlsx`,
    'Historiales',
    'Listado de Historiales Clínicos'
  );
};
export const exportCompaniesToExcel = (companies: any[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Industria',
    key: 'industria',
    width: 150
  },
  {
    header: 'Tamaño',
    key: 'tamano',
    width: 150
  },
  {
    header: 'Ubicación',
    key: 'ubicacion',
    width: 150
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  },
  {
    header: 'Sitio Web',
    key: 'sitioWeb',
    width: 250
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 300
  },
  {
    header: 'Fecha de Registro',
    key: 'fecha',
    width: 150
  }];


  const data: ExcelRow[] = companies.map((company) => ({
    id: company.id,
    nombre: company.name,
    industria: company.industry,
    tamano: company.size,
    ubicacion: company.location,
    telefono: company.phone,
    email: company.email,
    sitioWeb: company.website || '',
    notas: company.notes || '',
    fecha: formatDate(company.createdAt)
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `empresas_${timestamp}.xlsx`,
    'Empresas',
    'Listado de Empresas'
  );
};
export const exportLeadsToExcel = (leads: any[]) => {
  const columns: ExcelColumn[] = [
  {
    header: 'ID',
    key: 'id',
    width: 150
  },
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'Teléfono',
    key: 'telefono',
    width: 150
  },
  {
    header: 'Email',
    key: 'email',
    width: 250
  },
  {
    header: 'Fuente',
    key: 'fuente',
    width: 150
  },
  {
    header: 'Estado',
    key: 'estado',
    width: 150
  },
  {
    header: 'Servicio de Interés',
    key: 'servicio',
    width: 200
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 300
  },
  {
    header: 'Fecha de Registro',
    key: 'fecha',
    width: 150
  }];


  const data: ExcelRow[] = leads.map((lead) => ({
    id: lead.id,
    nombre: lead.name,
    telefono: lead.phone,
    email: lead.email,
    fuente: lead.source,
    estado: lead.status,
    servicio: lead.interestedService,
    notas: lead.notes || '',
    fecha: formatDate(lead.createdAt)
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `leads_${timestamp}.xlsx`,
    'Leads',
    'Listado de Leads'
  );
};
export const exportAuditLogsToExcel = (auditLogs: AuditLog[]) => {
  const getActionName = (action: string): string => {
    switch (action) {
      case 'create':
        return 'Creación';
      case 'update':
        return 'Actualización';
      case 'delete':
        return 'Eliminación';
      case 'complete':
        return 'Completado';
      case 'cancel':
        return 'Cancelación';
      case 'reschedule':
        return 'Reprogramación';
      default:
        return action;
    }
  };
  const columns: ExcelColumn[] = [
  {
    header: 'Fecha y Hora',
    key: 'fechaHora',
    width: 200
  },
  {
    header: 'Usuario',
    key: 'usuario',
    width: 200
  },
  {
    header: 'Acción',
    key: 'accion',
    width: 150
  },
  {
    header: 'Módulo',
    key: 'modulo',
    width: 150
  },
  {
    header: 'Entidad',
    key: 'entidad',
    width: 200
  },
  {
    header: 'Detalles',
    key: 'detalles',
    width: 400
  },
  {
    header: 'Cambios',
    key: 'cambios',
    width: 300
  }];


  const data: ExcelRow[] = auditLogs.map((log) => ({
    fechaHora: new Date(log.timestamp).toLocaleString('es-DO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'America/Santo_Domingo'
    }),
    usuario: log.userName,
    accion: getActionName(log.action),
    modulo: log.module.charAt(0).toUpperCase() + log.module.slice(1),
    entidad: log.entityName,
    detalles: log.details,
    cambios: log.changes ?
    log.changes.
    map((c) => `${c.field}: "${c.oldValue}" → "${c.newValue}"`).
    join('; ') :
    ''
  }));
  const timestamp = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `bitacora_auditoria_${timestamp}.xlsx`,
    'Bitácora',
    'Bitácora de Auditoría - Savidna'
  );
};

export const exportDashboardRevenueToExcel = (
aptRows: any[],
productRows: any[],
dateFrom: string,
dateTo: string) =>
{
  const totalSvc = aptRows.reduce((a, b) => a + b.total, 0);
  const totalProd = productRows.reduce((a, b) => a + b.total, 0);
  const totalGen = totalSvc + totalProd;

  const columns: ExcelColumn[] = [
  {
    header: 'Fecha',
    key: 'fecha',
    width: 110,
    align: 'center'
  },
  {
    header: 'Tipo',
    key: 'tipo',
    width: 110,
    align: 'center'
  },
  {
    header: 'Paciente / Cliente',
    key: 'paciente',
    width: 240
  },
  {
    header: 'Concepto',
    key: 'concepto',
    width: 300
  },
  {
    header: 'Colaborador',
    key: 'colaborador',
    width: 180
  },
  {
    header: 'Total (DOP)',
    key: 'total',
    width: 140,
    format: 'currency'
  }];


  const combined = [
  ...aptRows.map((r) => ({ ...r, tipo: 'Cita', concepto: r.service })),
  ...productRows.map((r) => ({ ...r, tipo: 'Producto', concepto: r.product }))].
  sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  const data: ExcelRow[] = combined.map((r) => ({
    fecha: r.date,
    tipo: r.tipo,
    paciente: r.patient,
    concepto: r.concepto,
    colaborador: r.colaborador || '—',
    total: Number(r.total || 0)
  }));

  const fmt = (n: number) =>
  n.toLocaleString('es-DO', { style: 'currency', currency: 'DOP' });

  return downloadFormattedExcel(
    data,
    columns,
    `ingresos_${dateFrom}_${dateTo}.xlsx`,
    'Ingresos',
    'Reporte de Ingresos',
    {
      concepto: 'TOTAL GENERAL',
      total: totalGen
    },
    {
      subtitle: `${dateFrom} al ${dateTo}`,
      meta: [
      `Ingresos por servicios: ${fmt(totalSvc)}`,
      `Ingresos por productos: ${fmt(totalProd)}`,
      `Total general: ${fmt(totalGen)}`]

    }
  );
};

// ==================== DASHBOARD & STATS EXCEL EXPORT ====================

export const exportDashboardChartDataToExcel = (
chartData: {
  label: string;
  values: Record<string, string | number>;
}[],
columns: {
  header: string;
  key: string;
}[],
title: string,
dateRange?: {
  from: string;
  to: string;
}) =>
{
  if (chartData.length === 0) {
    alert('No hay datos para exportar');
    return;
  }
  const excelColumns: ExcelColumn[] = columns.map((c) => ({
    header: c.header,
    key: c.key,
    width: Math.max(120, Math.floor(900 / columns.length))
  }));
  const data: ExcelRow[] = chartData.map((item) => ({
    ...item.values
  }));
  const dateInfo = dateRange ? ` (${dateRange.from} al ${dateRange.to})` : '';
  const ts = new Date().toISOString().split('T')[0];
  const filename = title.
  toLowerCase().
  replace(/[^a-z0-9]+/g, '_').
  replace(/_+$/, '');
  return downloadFormattedExcel(
    data,
    excelColumns,
    `${filename}_${ts}.xlsx`,
    title.substring(0, 31),
    `${title}${dateInfo}`
  );
};
export const exportProductsToExcel = (
products: {
  id: string;
  name: string;
  sku: string;
  category: string;
  price: number;
  cost: number;
  stock: number;
  status: string;
  description?: string;
}[],
dateFrom?: string | null,
dateTo?: string | null) =>
{
  const columns: ExcelColumn[] = [
  {
    header: 'Nombre',
    key: 'nombre',
    width: 200
  },
  {
    header: 'SKU',
    key: 'sku',
    width: 120
  },
  {
    header: 'Categoría',
    key: 'categoria',
    width: 150
  },
  {
    header: 'Precio (DOP)',
    key: 'precio',
    width: 120
  },
  {
    header: 'Costo (DOP)',
    key: 'costo',
    width: 120
  },
  {
    header: 'Stock',
    key: 'stock',
    width: 80
  },
  {
    header: 'Estado',
    key: 'estado',
    width: 100
  },
  {
    header: 'Descripción',
    key: 'descripcion',
    width: 300
  }];


  let data2export = products;
  if (dateFrom && dateTo) {





    // products don't have date, just export all if no date filter applies
  }const data: ExcelRow[] = data2export.map((p) => ({ nombre: p.name, sku: p.sku || '', categoria: p.category || '', precio: p.price,
      costo: p.cost,
      stock: p.stock,
      estado:
      p.status === 'active' ?
      'Activo' :
      p.status === 'inactive' ?
      'Inactivo' :
      p.status === 'archived' ?
      'Archivado' :
      p.status,
      descripcion: p.description || ''
    }));
  const ts = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `productos_${ts}.xlsx`,
    'Productos',
    'Listado de Productos'
  );
};
export const exportProductSalesToExcel = (
sales: any[],
getPatientName: (id: string) => string,
dateFrom?: string | null,
dateTo?: string | null) =>
{
  const columns: ExcelColumn[] = [
  {
    header: 'Fecha',
    key: 'fecha',
    width: 120
  },
  {
    header: 'Cliente',
    key: 'cliente',
    width: 200
  },
  {
    header: 'Vendedor',
    key: 'vendedor',
    width: 180
  },
  {
    header: 'Productos',
    key: 'productos',
    width: 300
  },
  {
    header: 'Total (DOP)',
    key: 'total',
    width: 120
  },
  {
    header: 'Descuento (DOP)',
    key: 'descuento',
    width: 140
  },
  {
    header: 'Notas',
    key: 'notas',
    width: 250
  }];


  let data2export = sales;
  if (dateFrom && dateTo) {
    data2export = sales.filter((s: any) => {
      const d = (s.date || '').toString().split('T')[0];
      return d >= dateFrom && d <= dateTo;
    });
  }
  const data: ExcelRow[] = data2export.map((s: any) => ({
    fecha: (s.date || '').toString().split('T')[0],
    cliente: getPatientName(s.patientId),
    vendedor: s.createdByUserName || '',
    productos: Array.isArray(s.items) ?
    s.items.
    map(
      (it: any) =>
      `${it.quantity || 1}x ${it.productName || it.productId || ''}`
    ).
    join(', ') :
    '',
    total: Number(s.total || 0),
    descuento: Number(s.discountTotal || s.discount_total || 0),
    notas: s.notes || ''
  }));
  // Totales de las ventas exportadas
  const totalVentas = data.reduce((sum, row) => sum + Number(row.total || 0), 0);
  const totalDescuentos = data.reduce(
    (sum, row) => sum + Number(row.descuento || 0),
    0
  );
  const unidades = data2export.reduce(
    (sum: number, s: any) =>
    sum + (
    Array.isArray(s.items) ?
    s.items.reduce(
      (n: number, it: any) => n + Number(it.quantity || 1),
      0
    ) :
    0),
    0
  );

  const ts = new Date().toISOString().split('T')[0];
  return downloadFormattedExcel(
    data,
    columns,
    `ventas_productos_${ts}.xlsx`,
    'Ventas',
    'Listado de Ventas de Productos',
    {
      productos: 'TOTAL GENERAL',
      total: totalVentas,
      descuento: totalDescuentos
    },
    {
      subtitle: dateFrom && dateTo ? `${dateFrom} al ${dateTo}` : undefined,
      meta: [
      `Ventas: ${data.length}`,
      `Unidades vendidas: ${unidades}`,
      `Total vendido: ${totalVentas.toLocaleString('es-DO', {
        style: 'currency',
        currency: 'DOP'
      })}`,
      `Descuentos: ${totalDescuentos.toLocaleString('es-DO', {
        style: 'currency',
        currency: 'DOP'
      })}`]

    }
  );
};
export const exportProductStatsToExcel = (
productStats: any[],
revenueTrend: any[],
totals: {
  revenue: number;
  units: number;
  profit: number;
},
dateFrom?: string | null,
dateTo?: string | null) =>
{
  const columns: ExcelColumn[] = [
  {
    header: 'Producto',
    key: 'producto',
    width: 220
  },
  {
    header: 'Unidades Vendidas',
    key: 'unidades',
    width: 140
  },
  {
    header: 'Ingresos (DOP)',
    key: 'ingresos',
    width: 140
  },
  {
    header: 'Ganancia (DOP)',
    key: 'ganancia',
    width: 140
  }];


  const data: ExcelRow[] = (productStats || []).map((p: any) => ({
    producto: p.name || p.productName || '',
    unidades: Number(p.units || p.quantity || 0),
    ingresos: Number(p.revenue || 0),
    ganancia: Number(p.profit || 0)
  }));
  data.push({
    producto: 'TOTAL',
    unidades: totals.units,
    ingresos: totals.revenue,
    ganancia: totals.profit
  });
  const ts = new Date().toISOString().split('T')[0];
  const suffix = dateFrom && dateTo ? `_${dateFrom}_${dateTo}` : '';
  return downloadFormattedExcel(
    data,
    columns,
    `estadisticas_productos${suffix}_${ts}.xlsx`,
    'Estadísticas',
    'Estadísticas de Ventas de Productos'
  );
};